export default __webpack_public_path__ + "static/media/thumbs-up-image.128703c4.png";